<script setup>
import { computed } from 'vue';

const props = defineProps({
  icon: {
    type: String,
    required: true
  },
  color: {
    type: String,
    default: '#333'
  },
  size: {
    type: [Number, String],
    default: 48
  }
});

const svgStyle = computed(() => ({
  width: typeof props.size === 'number' ? `${props.size}px` : props.size,
  height: typeof props.size === 'number' ? `${props.size}px` : props.size,
  color: props.color
}));
</script>

<template>
  <div class="svg-icon" v-html="icon" :style="svgStyle"></div>
</template>

<style scoped>
.svg-icon {
  display: inline-block;
  border-radius: 10px;
  background: #f8f9fa;
  padding: 10px;
  box-shadow: #ccc 0px 0px 6px 1px;
}

.svg-icon :deep(svg) {
  width: 100%;
  height: 100%;
}
</style> 